const ERROR_MESSAGE = {
  // Compliance
  GET_COMPLIANCE_LIST_FAILURE: 'Failed to fetch compliance list',
  GET_COMPLIANCE_DETAILS_FAILURE: 'Failed to fetch compliance details',

  // Students
  GET_STUDENT_LIST_FAILURE: 'Failed to fetch student list',
  GET_STUDENT_ATTENDANCE_FAILURE: 'Failed to fetch student attendance',
  GET_STUDENT_FEES_FAILURE: 'Failed to fetch student fees',

  // Events
  GET_EVENTS_FAILURE: 'Failed to fetch events',

  // Finance
  GET_FINANCE_LIST_FAILURE: 'Failed to fetch finance list',
  CREATE_FINANCE_RECORD_FAILURE: 'Failed to create finance record',
  PATCH_FINANCE_RECORD_FAILURE: 'Failed to update finance record',
  DELETE_FINANCE_RECORD_FAILURE: 'Failed to delete finance record',
  CREATE_FINANCE_GRANT_FAILURE: 'Failed to create finance grant',
  PATCH_FINANCE_GRANT_FAILURE: 'Failed to update finance grant',
  DELETE_FINANCE_GRANT_FAILURE: 'Failed to delete finance grant',
  GET_FINANCE_GRANT_BY_ID_FAILURE: 'Failed to fetch finance grant by id',

  // Staff
  GET_STAFF_LIST_FAILURE: 'Failed to fetch staff list',
  GET_STAFF_ATTENDANCE_FAILURE: 'Failed to fetch staff attendance',
  GET_STAFF_PAYOUT_FAILURE: 'Failed to fetch staff payouts',

  // Inventory
  GET_INVENTORY_ITEMS_FAILURE: 'Failed to fetch inventory items',
  GET_INVENTORY_ITEM_FAILURE: 'Failed to fetch inventory item',
  CREATE_INVENTORY_ITEM_FAILURE: 'Failed to create inventory item',
  UPDATE_INVENTORY_ITEM_FAILURE: 'Failed to update inventory item',
  DELETE_INVENTORY_ITEM_FAILURE: 'Failed to delete inventory item',
  GET_INVENTORY_TRANSACTIONS_FAILURE: 'Failed to fetch inventory transactions',
  GET_INVENTORY_TRANSACTION_FAILURE: 'Failed to fetch inventory transaction',
  CREATE_INVENTORY_TRANSACTION_FAILURE:
    'Failed to create inventory transaction',
  UPDATE_INVENTORY_TRANSACTION_FAILURE:
    'Failed to update inventory transaction',
  DELETE_INVENTORY_TRANSACTION_FAILURE:
    'Failed to delete inventory transaction',
  GET_INVENTORY_CATEGORIES_FAILURE: 'Failed to fetch inventory categories',
  GET_INVENTORY_CATEGORY_FAILURE: 'Failed to fetch inventory category',
  CREATE_INVENTORY_CATEGORY_FAILURE: 'Failed to create inventory category',
  UPDATE_INVENTORY_CATEGORY_FAILURE: 'Failed to update inventory category',
  DELETE_INVENTORY_CATEGORY_FAILURE: 'Failed to delete inventory category',

  // Vehicles
  GET_VEHICLES_FAILURE: 'Failed to fetch vehicles',
  GET_VEHICLE_FAILURE: 'Failed to fetch vehicle',
  CREATE_VEHICLE_FAILURE: 'Failed to create vehicle',
  UPDATE_VEHICLE_FAILURE: 'Failed to update vehicle',
  DELETE_VEHICLE_FAILURE: 'Failed to delete vehicle',

  // Drivers
  GET_DRIVERS_FAILURE: 'Failed to fetch drivers',
  GET_DRIVER_FAILURE: 'Failed to fetch driver',
  CREATE_DRIVER_FAILURE: 'Failed to create driver',
  UPDATE_DRIVER_FAILURE: 'Failed to update driver',
  DELETE_DRIVER_FAILURE: 'Failed to delete driver',

  // Routes
  GET_ROUTES_FAILURE: 'Failed to fetch routes',
  GET_ROUTE_FAILURE: 'Failed to fetch route',
  CREATE_ROUTE_FAILURE: 'Failed to create route',
  UPDATE_ROUTE_FAILURE: 'Failed to update route',
  DELETE_ROUTE_FAILURE: 'Failed to delete route',

  // Route Assignments
  GET_ROUTE_ASSIGNMENTS_FAILURE: 'Failed to fetch route assignments',
  GET_ROUTE_ASSIGNMENT_FAILURE: 'Failed to fetch route assignment',
  CREATE_ROUTE_ASSIGNMENT_FAILURE: 'Failed to create route assignment',
  UPDATE_ROUTE_ASSIGNMENT_FAILURE: 'Failed to update route assignment',
  DELETE_ROUTE_ASSIGNMENT_FAILURE: 'Failed to delete route assignment',

  // Generic
  GENERIC_ERROR: 'An error occurred. Please try again.',
};

export default ERROR_MESSAGE;
